<script>
  import {onMount} from 'svelte';
  import {url} from '@sveltech/routify';

  import Loading from "../../Components/UI/Loading.svelte";
  import Error from "../../Components/UI/Error.svelte";
  import Boton from "../../Components/UI/Boton.svelte";
  import Titulo from "../../Components/UI/Titulo.svelte";
  import ParrillaDeUsuarios from '../../Components/Usuarios/Parrilla/index.svelte';

  import store from '../../Stores/usuarios-store';
  import Modal from "../../Components/UI/Modal.svelte";
  import Icono from "../../Components/UI/Icono.svelte";

  onMount(() => store.cargar());
  $: error = $store.error;

  let usuarioEliminado, usuarios, errorEliminacion;
  $: usuarioEliminado = $store.usuarioEliminando;
  $: errorEliminacion = $store.errorEliminacion;

  const eliminarUsuario = e => store.eliminarTipo(e.detail);
  const eliminaUsuarioDeVerdad = () => store.eliminaTipoDeVerdad(usuarioEliminado);

  let activos = true;

  $: usuarios = $store.listado;
</script>

<style>
    .nuevo-tipo {
        margin-top: var(--padding-global);
    }

    .filtro {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: var(--padding-global);
        letter-spacing: .15em;
    }

    label {
        margin-left: .5em;
    }

    label:not(:last-child) {
        margin-right: 1em;
    }
</style>

<svelte:head>
    <title>Usuarios</title>
</svelte:head>

<Titulo>Usuarios</Titulo>

{#if $store.cargando }
    <Loading/>
{/if}

{#if error}
    <Error on:cancel={() => error = false}>{$store.error}</Error>
{/if}

{#if usuarios.length }
    <div>
        <ParrillaDeUsuarios on:eliminar-usuario={eliminarUsuario} {usuarios}/>

        <div class="nuevo-tipo">
            <Boton href="{$url('../nuevo')}">Nuevo usuario</Boton>
        </div>
    </div>
{/if}

{#if usuarioEliminado}
    <Modal title="¿Está seguro de que desea eliminar el usuario {usuarioEliminado.nombre}?"
           error={errorEliminacion}>
        <div slot="footer" class="opciones">
            <Boton on:click={eliminaUsuarioDeVerdad} tipo="peligro">
                <Icono>check</Icono>
                Confirmar
            </Boton>
            <Boton on:click={() => usuarioEliminado = false} tipo="neutral">
                <Icono>cancel</Icono>
                Cancelar
            </Boton>
        </div>
    </Modal>
{/if}